import React from 'react'
import SCR from '../components/SCR.js';
import {Container, Row, Col} from 'react-bootstrap';

export default class Progress extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      isPanelOpen : false,
      panelClass : '',
      navClass : 'nav nav-justified'
    };

    this.handleOpenPanel = this.handleOpenPanel.bind(this);
    this.modifyDatesClick = this.modifyDatesClick.bind(this);
    this.changeVehicleClick = this.changeVehicleClick.bind(this);
    this.changeExtrasClick = this.changeExtrasClick.bind(this);
    this.goToReviewClick = this.goToReviewClick.bind(this);
    this.adjustTime = this.adjustTime.bind(this);
  }

  componentDidUpdate(){
    //console.log('updating')
    setTimeout(function(){
      SCR.resizeParent();
    }, 2000)

  }

  // handle button click
  modifyDatesClick(e){
    e.preventDefault();
    var self = this;
    //console.log('clicked');

    self.props.returnToStep(1);
  }

  // handle button click
  changeVehicleClick(e){
    e.preventDefault();
    var self = this;
    //console.log('clicked');
    //console.log(this.props)
    self.props.returnToStep(2);
  }

  // handle button click
  changeExtrasClick(e){
    e.preventDefault();
    var self = this;
    self.props.returnToStep(3);
  }

  goToReviewClick(e){
    e.preventDefault();
    var self = this;
    self.props.returnToStep(4);
  }

  handleOpenPanel(e){
    e.preventDefault();
    //console.log(this.state.isPanelOpen)
    if(!this.state.isPanelOpen)
      this.setState({ isPanelOpen : true, panelClass : 'open', navClass : 'nav flex-column'}, () => {SCR.resizeParent();});
    else
      this.setState({ isPanelOpen : false, panelClass : '', navClass : 'nav nav-justified'}, () => {SCR.resizeParent();});
  }

  adjustTime(time){
      var tmp = time.split(':');
      var hour = parseInt(tmp[0]);
      if(hour > 12)
        hour = hour - 12;

      return ('0' + (hour)).slice(-2) + ':' + tmp[1];
  }

  render() {
    let ChangeVehicle,/*TotalCost,*/ChangeDate,Extras,Review;
    //if(this.props.currentStep > 3)
    //TotalCost = "Total $ ***NEED TO SAVE***"

    // activate change buttons
    if(this.props.currentStep > 1){
      ChangeDate =
      <div className="progress-inner">
          <a href="#" onClick={this.modifyDatesClick}>
          {this.props.pickup.locationCity} - {this.props.pickup.locationId}<br/>
          {SCR.prettyDate(this.props.pickup.date)} {this.adjustTime(this.props.pickup.time)}<br/>
          {this.props.dropoff.locationCity} - {this.props.dropoff.locationId}<br/>
          {SCR.prettyDate(this.props.dropoff.date)} {this.adjustTime(this.props.dropoff.time)}
        </a>
      </div>;
    }
    if(this.props.currentStep > 2 || this.props.vehicleClass !== '' ){
      ChangeVehicle =
      <div className="progress-inner">
        <a href="#" onClick={this.changeVehicleClick}>{this.props.vehicleClass.modelDesc}</a>
      </div>;
    }

    //console.log('progress extras = ')
    //console.log(this.props.isModifyRez)
    if(this.props.currentStep > 3 || (typeof this.props.extras !== 'undefined' && this.props.extras.length > 0) || this.props.isModifyRez){
      //console.log(this.props.extras)
      var extrasCount = 0;
      if(typeof this.props.extras !== 'undefined')
        extrasCount = this.props.extras.length;

      var extrasText = '';
      if(extrasCount === 0 || extrasCount > 1)
        extrasText = extrasCount + ' Extras';
      else if(extrasCount === 1)
        extrasText = extrasCount + ' Extra';

      Extras =
      <div className="progress-inner">
        <a href="#" onClick={this.changeExtrasClick}>{extrasText}</a>
      </div>;
    }

    if(this.props.personalInfo !== ''){
      Review =
      <div className="progress-inner">
        <a href="#" onClick={this.goToReviewClick}>Review Details</a>
      </div>;
    }

    return (<>
      <Container id="progress" fluid>
        <Row id="mobile-header" xs={5} className="d-xs-block d-md-none d-lg-none d-xl-none d-xxl-none">
          <Col className={`nav-item ${this.props.currentStep === 1 ? "active" : ""}`}>
            <span className="circle-num"><span>1</span></span>
            <span className="progress-desc">Dates/Location</span>
          </Col>
          <Col className={`nav-item ${this.props.currentStep === 2 ? "active" : ""}`}>
            <span className="circle-num"><span>2</span></span>
            <span className="progress-desc">Vehicle</span>
          </Col>
          <Col className={`nav-item ${this.props.currentStep === 3 ? "active" : ""}`}>
            <span className="circle-num"><span>3</span></span>
            <span className="progress-desc">Extras</span>
          </Col>
          <Col className={`nav-item ${this.props.currentStep === 4 ? "active" : ""}`}>
            <span className="circle-num"><span>4</span></span>
            <span className="progress-desc">Review</span>
          </Col>
          <Col className={`nav-item ${this.props.currentStep === 4 ? "active" : ""}`}>
            Total ${this.props.price || "0.00"}
            <button id="progress-panel-button" onClick={this.handleOpenPanel} className={this.state.panelClass}>
              {this.state.isPanelOpen ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
            </button>
          </Col>
        </Row>
      </Container>

        <div id="progress-panel" className={this.state.panelClass}>
          <div id="progress-panel-background"></div>
          <ul className={this.state.navClass}>
            <li className={`nav-item ${this.props.currentStep === 1 ? "active" : ""}`}>
              <span className="circle-num"><span>1</span></span>
              <span className="progress-desc">Dates/Location</span>
              {ChangeDate}
            </li>
            <li className={`nav-item ${this.props.currentStep === 2 ? "active" : ""}`}>
              <span className="circle-num"><span>2</span></span>
              <span className="progress-desc">Vehicle</span>
              {ChangeVehicle}
            </li>
            <li className={`nav-item ${this.props.currentStep === 3 ? "active" : ""}`}>
              <span className="circle-num"><span>3</span></span>
              <span className="progress-desc">Extras</span>
              {Extras}
            </li>
            <li className={`nav-item ${this.props.currentStep === 4 ? "active" : ""}`}>
              <span className="circle-num"><span>4</span></span>
              <span className="progress-desc">Review</span>
              {Review}
            </li>
            <li className="nav-item d-none d-md-block">
            Total ${this.props.price || "0.00"}
            </li>
          </ul>
        </div>

      </>
    );
  }
}
/*
<div id="progress" className="container" style={{padding: 0}}>
  <div id="mobile-header" className="d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none">
    <ul className="nav nav-justified">
      <li className={`nav-item ${this.props.currentStep === 1 ? "active" : ""}`}>
        <span className="circle-num"><span>1</span></span>
        <span className="progress-desc">Dates/Location</span>
      </li>
      <li className={`nav-item ${this.props.currentStep === 2 ? "active" : ""}`}>
        <span className="circle-num"><span>2</span></span>
        <span className="progress-desc">Vehicle</span>
      </li>
      <li className={`nav-item ${this.props.currentStep === 3 ? "active" : ""}`}>
        <span className="circle-num"><span>3</span></span>
        <span className="progress-desc">Extras</span>
      </li>
      <li className={`nav-item ${this.props.currentStep === 4 ? "active" : ""}`}>
        <span className="circle-num"><span>4</span></span>
        <span className="progress-desc">Review</span>
      </li>
      <li className="nav-item">
        Total ${this.props.price || "0.00"}
        <button id="progress-panel-button" onClick={this.handleOpenPanel} className={this.state.panelClass}>
          <i class="bi bi-caret-down-fill"></i>
        </button>
      </li>
    </ul>
  </div>*/
